import { render, staticRenderFns } from "./RegisterHousehold.vue?vue&type=template&id=704a57d3&"
import script from "./RegisterHousehold.vue?vue&type=script&lang=js&"
export * from "./RegisterHousehold.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports